<!-- 
  <p-dataTable
   [value]="Dataset" 
   [responsive]="true" 
   [resizableColumns]="true" 
   columnResizeMode="expand" 
   [paginator]="true"
   [(selection)]="selectedRow" 
   selectionMode="single" 
   appendTo="body" 
   [rows]="rowcount" 
   [pageLinks]="15" 
   [totalRecords]="totalRecords" 
   (onPage)="changePage($event)" 
   [immutable]=false
   [rowsPerPageOptions]="rowsPerPageOptions" 
   [lazy]="true" 
   #dt>

    <p-column *ngFor="let col of cols;let j=index;" [style]="{'display':col.display} " [field]="col.field" [header]="col.header | titlecase"
      [sortable]="false" filterMatchMode="in" (mouseleave)="hoveredIndex=null" appendTo="body">
      <ng-template let-row="rowData" let-i="rowIndex" pTemplate="body">
        <div [pTooltip]="row[col.field]" [id]="col.field"></div>

        !-- set Action icons  --
        <span *ngIf="col.field =='action' ">
          <p-button matTooltip="View" matTooltipPosition="after" appendTo="body" icon="fa fa-fw fa-eye"
            (click)="onRowSelect('View',i,row)"></p-button>
        </span>

        !-- set String --
        <span *ngIf="(col.datatype | lowercase) !='int' && (col.datatype | lowercase) !='float'">
            <span  (click)="onRowSelect('OrderID',i,row)" *ngIf="(col.header | lowercase) =='order id' " >
                <a style="color: blue">{{row[col.field]}}</a>
              </span>
              <span *ngIf="(col.header | lowercase) !='order id' "  >
                  {{row[col.field]}}
              </span>
        </span>
        
        !-- set int  --
        <span style="float:right;" *ngIf="(col.datatype | lowercase) =='int' || (col.datatype | lowercase) =='float' ">
          {{row[col.field] * 1 }}
        </span>

      </ng-template>
    </p-column>
    <p-footer>
      <span style="float:left"> Page No - {{pageNumber }}</span>
      {{Dataset?.length == 0?  0 : startLimit + 1}} to {{Dataset?.length < rowcount ? Dataset?.length  <  startLimit ? endLimit : Dataset?.length : endLimit}} 
      <span style="float:right">  Total Records: {{Dataset?.length == 0?  0 : totalRecords}}  </span>
    </p-footer>
  </p-dataTable> -->
<div class="card" (mouseup)="commonColService.stopDragging()" (mouseleave)="commonColService.stopDragging()">
  <p-contextMenu #cm [model]="commonColService.menuItems" appendTo="body"  styleClass="column-context-menu"></p-contextMenu>   
<p-table #dt
 [columns]="commonColService.selectedColumns" 
[value]="Dataset" 
[class.table-frozen]="commonColService.isFrozenColumns"
[resizableColumns]="true"
columnResizeMode="expand" 
[pageLinks]="15"
[totalRecords]="totalRecords"
[paginator]="true" 
[(selection)]="selectedRow" 
selectionMode="single" 
alwaysShowPaginator="true" 
paginatorPosition="both"
showCurrentPageReport="true" 
appendTo="body" 
[rows]="rowcount" 
(onPage)="changePage($event)" 
sortMode="multiple"
(onSort)="sort($event)"
[rowsPerPageOptions]="rowsPerPageOptions" 
[sortOrder]="constantService.DEFAULT_SORDORDER_ASC"
styleClass="p-datatable-gridlines p-datatable-striped"
[pageLinks]="constantService.GRID_DEFAULT_PAGELINKS" 
[lazy]="true"
[scrollable]="true" 
scrollHeight="60vh"
[reorderableColumns]="true"
(onColReorder)="commonColService.onColumnsReordered($event, dt)"
[styleClass]="(PageName === 'caisErrorCode' || PageName === 'catErrorCode' || PageName === 'System-Monitoring') ? 'errortable p-datatable-gridlines p-datatable-striped' : 'gridtable p-datatable-gridlines p-datatable-striped'">
      
     <ng-template pTemplate="emptymessage" let-columns>
        <tr>
            <td [attr.colspan]="columns.length">
                No records found
            </td>
        </tr>
    </ng-template>
    <!-- <ng-template pTemplate="colgroup" let-columns>
        <colgroup>
            <col *ngFor="let col of columns" [style.width]="col.width" pResizableColumn>
        </colgroup>
    </ng-template> -->
      <ng-template pTemplate="header" let-columns>
          <tr>
             <!-- <th style="width: 3em">
                <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
            </th> -->
              @for (col of columns; track col.field + '-' + $index){
              <th [attr.id]="'col-' + col.field"
                pResizableColumn  
                [pSortableColumn]="col.field" 
                pFrozenColumn 
                pReorderableColumn
                [frozen]="col.frozen" 
                alignFrozen="left"
                [style.min-width]="col.width || '180px'" 
                [style.max-width]="col.width || '180px'"
                [style.width]="col.width || '180px'" 
                [style.left]="col.frozen ? $any(col).stickyLeft : 'auto'"
                [style.background-color]="col.frozen && !commonColService.selectedFields.includes(col.field) ? 'sortClass' : null"
                [class.selected-header]="commonColService.selectedFields.includes(col.field)"
                [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay' : ''"
                (mousedown)="commonColService.onHeaderMouseDown($event, col.field)"
                (mouseenter)="commonColService.onHeaderMouseEnter(col.field)"
                (contextmenu)="commonColService.onHeaderContextMenu($event, col.field,contextMenuItems, dt)" >
                  
                  <div class="header-cell-content">
                      <span class="excel-cursor-span" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                          {{col.header}}
                          @if((col.header | lowercase) !== 'action'){
                              <p-sortIcon [field]="col.field"></p-sortIcon>
                          }
                      </span>
                      @if(col.frozen) {
                          <i class="pi pi-lock" style="font-size: 0.85rem; color: #000; margin-left: 4px;"></i>
                      }
                  </div>
              </th>
              }
          </tr>
      </ng-template>

      <ng-template pTemplate="body" let-row let-ri="rowIndex" let-columns="columns">
          <tr [pSelectableRow]="row" [ngClass]="(row['modified'] | lowercase) == 'u' ? 'ui-widget-updated-row' : (row['modified'] | lowercase) == 'd' ? 'ui-widget-deleted-row .ui-chkbox ' : 'ui-widget-NoUpdated-row'">
              @for (col of columns; track col.field + '-' + $index){
              <td 
                class="ui-resizable-column" 
                pFrozenColumn
                [frozen]="col.frozen" 
                alignFrozen="left"
                [style.min-width]="col.width || '180px'" 
                [style.max-width]="col.width || '180px'"
                [style.width]="col.width || '180px'"
                [style.left]="col.frozen ? $any(col).stickyLeft : 'auto'"
                [style.background-color]="selectedRow === row ? '#88c0eb': (col.frozen ? '#e2f0d9' : null)"
                [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay' : ''">
                  
                  <div style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; width: 100%;">
                      @if((col?.field | lowercase) == 'eventtype'){
                          <span matTooltipPosition="right" [matTooltip]="constantService.EVENT_DESCRIPTION_BY_EVENT_TYPE[row[col.field]]">
                              {{row[col.field]}}
                          </span>
                      }
                  </div>

                  @if(col?.field == 'action'){
                      <span>
                          <p-button matTooltip="View" [matTooltipShowDelay]="1000" matTooltipPosition="after" appendTo="body" icon="fa fa-fw fa-eye" (click)="onRowSelect('View', row)"></p-button>
                      </span>
                  }

                <!-- set String -->
                 @if((col.datatype | lowercase) !='int' && (col.datatype | lowercase) !='float'){
                <span>
                    <!-- <span  (click)="onRowSelect('OrderID',i,row)" *ngIf="(col.header | lowercase) =='order id' || (col.header | lowercase) =='orderid' " >
                        <a routerLink="/pages/Order-Viewer"  onclick=" window.open('/pages/Order-Viewe',
                        'newwindow',
                        'width=auto,height=auto');
                          return false;" target="_blank" style="color: blue">{{row[col.field]}}</a>
                      </span> -->
                <!-- routerLink="{{'/pages/Order-Viewer/'+ row}}" target="_blank" -->
                 @if((col.header | lowercase) =='order id' || (col.header | lowercase) =='orderid' ){
                <span (click)="PageName !=='cmtaDetail' ?onRowSelect('OrderID',row): ''">
                     <a [style]="PageName !=='cmtaDetail' ?'color: #337ab7;cursor: pointer' : ''">{{row[col.field]}}</a>
                      </span>
                }

                @if((col.header | lowercase) !='order id' && (col.header | lowercase) !='orderid' && (col.header | lowercase) != 'option id' && (col.header | lowercase) != 'symbol' && (col?.field | lowercase) !='eventtype'){
                <span [ngClass]="(gethighLightedCellClass(row, col) ? 'text-error bold-txt' : '')" >
                  {{row[col.field]}}
                      </span>}
                  @if((col.header | lowercase)=='option id' || (col.header | lowercase)=='symbol'){
                  <div class="pull-right" [ngClass]="'displayWhitespaces'">
                      {{row[col.field]}}
                  </div>
                  }    
                </span>
              }

                <!-- set int  -->
                 @if((col.datatype | lowercase) =='int' || (col.datatype | lowercase) =='float' ){
                <span style="float:right;">
                  @if(row[col.field]){
                  <span>{{row[col.field] * 1 }}</span>
                }
                </span>
              }

            </td>}
        </tr>
    </ng-template>
    <ng-template pTemplate="paginatorright">
      @if(isExportEnabled){
        <app-export-to-csv [gridColumns]="GridColumns" [OptedExportCSVGridColumns]="OptedExportCSVGridColumns" (exportToCSVListner)="exportToCSV($event)"></app-export-to-csv>
        }
        Total Records: {{Dataset.length == 0? 0 :  displayTildCount ? '~'+totalRecords : totalRecords}}
    </ng-template>
    <ng-template pTemplate="paginatorleft">
        <!-- <div style="text-align:left">
              <p-multiSelect  mat-accent  appendTo="body"   [options]="GridColumns" [(ngModel)]="selectedColumns" optionLabel="header"
                          selectedItemsLabel="{0} columns selected" [style]="{minWidth: '300px'}" placeholder="Choose Columns"></p-multiSelect>
          </div> -->
        <!-- Page No : {{pageNumber }} -->
         @if(Dataset){
        <span>Showing {{Dataset.length == 0? 0 : startLimit + 1}} to
        {{Dataset.length < rowcount ? Dataset.length < startLimit ? endLimit : Dataset.length : endLimit}}
       entries  </span>}
    </ng-template>
</p-table>

<!-- Quick View Panel Code  -->
<app-quickview-sidebar [columnJSON]="quickviewcols" [selectedData]="selectedRowData" [display]="isQuickViewOpenClose" (CloseEvent)="QuickViewCloseEvent($event)">
</app-quickview-sidebar>
<br>